import instance from './common';

export function getActiveOutliers(reqBody, options = {}, http = instance) {
  return http.post('/ai-roadmap/activefeeds', reqBody, options);
}

export function getArchivedOutliers(reqBody, options = {}, http = instance) {
  return http.post('/ai-roadmap/archivedfeeds', reqBody, options);
}
